const checkboxClasses =
  "focus:ring-freshgreen-500 h-4 w-4 text-brightgreen-500 border-gray-300 rounded";
export default checkboxClasses;
